import { Validator } from '@vista-digital/validator';
export const defaultFormDisplayText = {
    submitButtonLabel: 'Submit',
    cancelButtonLabel: 'Cancel'
};
export const formDisplayTextValidatorSchema = {
    submitButtonLabel: Validator.optional(Validator.nonEmptyString),
    cancelButtonLabel: Validator.optional(Validator.nonEmptyString)
};
//# sourceMappingURL=display-text.js.map